export default "__VITE_ASSET__j$52fv$e__"